import { MAX_ACTIVITY_MESSAGE_LENGTH } from './storage-limits';

export function parseActivityMessage(
    value: unknown
): string | null | undefined {
    if (value === undefined || value === null) return null;
    return typeof value === 'string' &&
        value.trim().length > 0 &&
        value.length <= MAX_ACTIVITY_MESSAGE_LENGTH
        ? value
        : undefined;
}
